
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5520',
  depVersions: {
  "data-privacy-request-ui": "static-1.5520",
  "data-fetching-client": "static-1.9662",
  "head-dlb": "static-1.4994",
  "hs-test-utils": "static-1.8005",
  "hub-http-shared-msw-handlers": "static-1.9939",
  "hubspot-dlb": "static-2.1845",
  "HubStyleTokens": "static-2.11461",
  "I18n": "static-7.1622",
  "jasmine-runner": "static-1.6458",
  "privacy-center-public-service-types": "static-1.4783",
  "quartz": "static-1.7021",
  "react-dlb": "static-1.78",
  "ui-components-test-utils": "static-1.5598",
  "UIComponents": "static-3.8407",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.85",
  "foundations-assets": "static-1.4856",
  "foundations-components": "static-1.7915",
  "foundations-components-test-utils": "static-1.5398",
  "foundations-theming": "static-1.4410",
  "hub-http": "static-1.6215",
  "quartz-config": "static-1.799",
  "quartz-core": "static-1.6240",
  "quartz-routing": "static-1.451",
  "quick-fetch": "static-1.3909",
  "raven": "static-3.5907",
  "react": "static-7.185",
  "react-rhumb": "static-1.16660",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11142",
  "usage-tracker": "static-1.7335",
  "usage-tracker-anonymous": "static-1.5752",
  "usage-tracker-core": "static-1.7185",
  "enviro": "static-4.446",
  "hs-promise-rejection-tracking": "static-1.5566",
  "PortalIdParser": "static-2.397",
  "raven-hubspot": "static-1.6214",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4115",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9619",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3393",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3298",
  "quartz-webpack": "static-1.3245",
  "bend-plugin-quartz-routing": "static-1.99",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.81",
  "HeadJS": "static-2.758",
  "framer-motion": "static-1.71",
  "hs-test-utils-bend-plugin": "static-1.3116",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "ts-schema": "static-1.4073",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.82",
  "react-utils": "static-2.5337",
  "StyleGuideUI": "static-3.487",
  "jasmine": "static-4.4319",
  "rpc-client-utils": "static-1.4642",
  "HubStyle": "static-2.11768",
  "ui-addon-draggable": "static-3.4756",
  "cssUtils": "static-1.788",
  "hs-story-utils": "static-1.9419",
  "icons": "static-2.646",
  "react-select-plus": "static-1.104",
  "react-virtualized": "static-2.98",
  "ui-images": "static-2.1151",
  "bend-plugin-foundations-components": "static-1.4184",
  "floating-ui": "static-1.55",
  "foundations-theming-specialty": "static-1.2126",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.20",
  "tanstack-table": "static-1.54",
  "trellis-assets": "static-1.1890",
  "ui-fonts": "static-1.723",
  "foundations-components-legacy": "static-1.940",
  "bend-plugin-foundations-theming": "static-1.2893",
  "foundations-theming-base": "static-1.3395",
  "stylex": "static-1.32",
  "hs-locale-management": "static-1.74",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.832",
  "hubspotter-http": "static-1.4645",
  "mobile-manifest-mixins": "static-1.533",
  "module-federation": "static-1.22",
  "quartz-auth": "static-1.696",
  "quartz-head": "static-1.686",
  "quartz-i18n": "static-1.696",
  "quartz-test": "static-1.696",
  "quartz-tracking": "static-1.400",
  "usage-tracker-container": "static-1.7325",
  "csstype": "static-1.50",
  "web-vitals": "static-1.4",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3199",
  "bend-plugin-chirp-manifest": "static-1.52",
  "chirp-fetch": "static-1.1879",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.69",
  "sassPrefix": "static-1.155",
  "hubspotter-http-shared-msw-handlers": "static-1.9937",
  "usage-tracker-session-replay": "static-1.5021",
  "amplitude-session-replay-browser": "static-1.59"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5520",
  "data-fetching-client": "/data-fetching-client/static-1.9662",
  "head-dlb": "/head-dlb/static-1.4994",
  "hs-test-utils": "/hs-test-utils/static-1.8005",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9939",
  "hubspot-dlb": "/hubspot-dlb/static-2.1845",
  "HubStyleTokens": "/HubStyleTokens/static-2.11461",
  "I18n": "/I18n/static-7.1622",
  "jasmine-runner": "/jasmine-runner/static-1.6458",
  "privacy-center-public-service-types": "/privacy-center-public-service-types/static-1.4783",
  "quartz": "/quartz/static-1.7021",
  "react-dlb": "/react-dlb/static-1.78",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5598",
  "UIComponents": "/UIComponents/static-3.8407",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.85",
  "foundations-assets": "/foundations-assets/static-1.4856",
  "foundations-components": "/foundations-components/static-1.7915",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5398",
  "foundations-theming": "/foundations-theming/static-1.4410",
  "hub-http": "/hub-http/static-1.6215",
  "quartz-config": "/quartz-config/static-1.799",
  "quartz-core": "/quartz-core/static-1.6240",
  "quartz-routing": "/quartz-routing/static-1.451",
  "quick-fetch": "/quick-fetch/static-1.3909",
  "raven": "/raven/static-3.5907",
  "react": "/react/static-7.185",
  "react-rhumb": "/react-rhumb/static-1.16660",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11142",
  "usage-tracker": "/usage-tracker/static-1.7335",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5752",
  "usage-tracker-core": "/usage-tracker-core/static-1.7185",
  "enviro": "/enviro/static-4.446",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5566",
  "PortalIdParser": "/PortalIdParser/static-2.397",
  "raven-hubspot": "/raven-hubspot/static-1.6214",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4115",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9619",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3393",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3298",
  "quartz-webpack": "/quartz-webpack/static-1.3245",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.99",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.81",
  "HeadJS": "/HeadJS/static-2.758",
  "framer-motion": "/framer-motion/static-1.71",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3116",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "ts-schema": "/ts-schema/static-1.4073",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.82",
  "react-utils": "/react-utils/static-2.5337",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "jasmine": "/jasmine/static-4.4319",
  "rpc-client-utils": "/rpc-client-utils/static-1.4642",
  "HubStyle": "/HubStyle/static-2.11768",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4756",
  "cssUtils": "/cssUtils/static-1.788",
  "hs-story-utils": "/hs-story-utils/static-1.9419",
  "icons": "/icons/static-2.646",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-virtualized": "/react-virtualized/static-2.98",
  "ui-images": "/ui-images/static-2.1151",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4184",
  "floating-ui": "/floating-ui/static-1.55",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2126",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.20",
  "tanstack-table": "/tanstack-table/static-1.54",
  "trellis-assets": "/trellis-assets/static-1.1890",
  "ui-fonts": "/ui-fonts/static-1.723",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.940",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2893",
  "foundations-theming-base": "/foundations-theming-base/static-1.3395",
  "stylex": "/stylex/static-1.32",
  "hs-locale-management": "/hs-locale-management/static-1.74",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.832",
  "hubspotter-http": "/hubspotter-http/static-1.4645",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.533",
  "module-federation": "/module-federation/static-1.22",
  "quartz-auth": "/quartz-auth/static-1.696",
  "quartz-head": "/quartz-head/static-1.686",
  "quartz-i18n": "/quartz-i18n/static-1.696",
  "quartz-test": "/quartz-test/static-1.696",
  "quartz-tracking": "/quartz-tracking/static-1.400",
  "usage-tracker-container": "/usage-tracker-container/static-1.7325",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.4",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3199",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.52",
  "chirp-fetch": "/chirp-fetch/static-1.1879",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.69",
  "sassPrefix": "/sassPrefix/static-1.155",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9937",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5021",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59"
}
};
